module.exports = __webpack_public_path__ + "static/media/combiDark.d96dc470.svg";